// removed by extract-text-webpack-plugin
module.exports = {"Works":"Works__Works__1SEQU","Row":"Works__Row__1dFXk","H1":"Works__H1__3-rjQ","Wrap":"Works__Wrap__3TtI0","Title":"Works__Title__uCo4V","Timg":"Works__Timg__2txao","Text":"Works__Text__2EtTp","Animate_Text":"Works__Animate_Text__20X8G"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Resume/Works/Works.css
// module id = 135
// module chunks = 0